// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  traceId: __t.u64().primaryKey().name("trace_id"),
  workspaceId: __t.u64().name("workspace_id"),
  roadId: __t.u64().name("road_id"),
  stepId: __t.u64().name("step_id"),
  turnId: __t.u64().name("turn_id"),
  kind: __t.string(),
  summary: __t.string(),
  atMicros: __t.i64().name("at_micros"),
});
